/**
 * Collapses the isLoading/isError/onRetry triple every `DataTable` consumer
 * wires up from its query by hand into a single spread:
 *   `<DataTable ... {...queryTableProps(query)} />`
 * Accepts both `useQuery` and `useInfiniteQuery` results.
 */
export function queryTableProps(query: {
  isLoading: boolean;
  isError: boolean;
  refetch: () => unknown;
}): { isLoading: boolean; isError: boolean; onRetry: () => void } {
  return {
    isLoading: query.isLoading,
    isError: query.isError,
    onRetry: () => void query.refetch(),
  };
}
